/**
 * Custom AudioPlayer
 * Written by Kieran.
 *
 * v1.0.0
 * @param val
 * @returns {string}
 */


const convertTimeHHMMSS = (val) => {
  let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);
  return (hhmmss.indexOf('00:') === 0) ? hhmmss.substr(3) : hhmmss
};

export default {
  methods: {
    initAudio() {
      let self = this;
      self.audio = self.$refs['audioFile'];
      self.audio.addEventListener('loadeddata', self.onAudioLoaded);
      self.audio.addEventListener('timeupdate', self.onAudioTimeUpdate);
      self.audio.addEventListener('ended', self.onAudioEnded);
    },
    onAudioLoaded() {
      let self = this;
      if (self.audio.readyState >= 2) {
        self.duration = self.audio.duration;
        self.volume = self.audio.volume;
        self.isAudioReady = true;
      }
    },
    onAudioTimeUpdate() {
      let self = this;
      const currentTime = parseInt(self.audio.currentTime);
      const audioDuration = self.duration;
      self.percentage = parseInt((currentTime / audioDuration) * 100);
      self.currentTime = convertTimeHHMMSS(currentTime);
      self.currentDuration = self.audio.currentTime;
    },
    onAudioEnded() {
      let self = this;
      self.currentDuration = 0;
      self.audio.currentTime = 0;
      self.pause();
    },
    playOrPause() {
      let self = this;
      self.isPlaying === false ? self.play() : self.pause();
    },
    play() {
      let self = this;
      self.isPlaying = true;
      self.audio.play();
    },
    pause() {
      let self = this;
      self.isPlaying = false;
      self.audio.pause()
    },
    mute() {
      let self = this;
      if (self.isMuted === true) {
        self.isMuted = false;
        self.volume = self.volumeBeforeMuted;
        self.setVolume(self.volumeBeforeMuted);
      }
      else {
        self.isMuted = true;
        self.volumeBeforeMuted = self.volume;
        self.volume = 0;
        self.setVolume(0);
      }
    },
    dragSeekDurationStarted() {
      let self = this;
      self.userSeeking = true;
      self.pause();
    },
    dragSeekDurationEnded() {
      let self = this;
      self.audio.currentTime = self.currentDuration;
      self.audio.currentDuration = self.currentDuration;
      self.$nextTick(function () {
        self.userSeeking = false;
        self.play();
      });
    },
    durationChanged(value) {
      let self = this;
      if (self.userSeeking === false) {
        self.currentDuration = value;
        self.audio.currentTime = self.currentDuration;
      }
    },
    setVolume(value) {
      let self = this;
      self.audio.volume = value
    },
    dragVolumeStarted() {
      let self = this;
    },
    dragVolumeEnded() {
      let self = this;
      self.audio.volume = self.volume;
    }
  },
  computed: {
    audioDuration() {
      let self = this;
      if (self.audio !== undefined) {
        return convertTimeHHMMSS(self.duration);
      }
    },
    audioIcon() {
      let self = this;
      let volume = self.volume;
      if (volume < .1) {
        return 'volume_off'
      }
      else if (volume <= .5) {
        return 'volume_down'
      }
      if (volume > .5) {
        return 'volume_up'
      }
    }
  },
  beforeDestroy() {
    let self = this;
    self.audio.removeEventListener('loadeddata', self.onAudioLoaded);
    self.audio.removeEventListener('timeupdate', self.onAudioTimeUpdate);
    self.audio.removeEventListener('ended', self.onAudioEnded);
    self.audio.src = "";
  }
}





// WEBPACK FOOTER //
// ./src/components/AudioPlayer/AudioPlayerMixin.js